import createSvgIcon from '@mui/material/utils/createSvgIcon';

const Icon = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2.25C6.61547 2.25 2.25 6.61547 2.25 12C2.25 17.3845 6.61547 21.75 12 21.75C17.3845 21.75 21.75 17.3845 21.75 12C21.75 6.61547 17.3845 2.25 12 2.25Z"
      stroke="black"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M12 2.25C9.27797 2.25 6.71859 6.61547 6.71859 12C6.71859 17.3845 9.27797 21.75 12 21.75C14.722 21.75 17.2814 17.3845 17.2814 12C17.2814 6.61547 14.722 2.25 12 2.25Z"
      stroke="black"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M5.49984 5.49982C7.29234 6.77247 9.54891 7.53138 12 7.53138C14.4511 7.53138 16.7077 6.77247 18.5002 5.49982"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5002 18.5001C16.7077 17.2275 14.4511 16.4686 12 16.4686C9.54891 16.4686 7.29234 17.2275 5.49984 18.5001"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 2.25V21.75"
      stroke="black"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M21.75 12H2.25"
      stroke="black"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>,
  'Globe'
);

export default Icon;
